<template>
  <div class="justify-center layout mt-n1">
    <v-btn color="success" small @click="updatePBX">Update HostedPBX</v-btn>
    <v-btn color="success" small @click="setDealer">Create Login</v-btn>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  methods: {
    setDealer() {
      this.params.clicked(this.params.data);
    },
    updatePBX() {
      this.params.updatePBX(this.params.data);
    },
  },
});
</script>
